import React from "react";

import { useQuery } from "@apollo/client";

// @ts-ignore
import { /*loader,*/ gql } from "graphql.macro";

import SunriseSunset from "./sunrise-sunset";

// TODO GET_ONE (but only lat/long/name)
const node = gql`
  query node($where: NodeWhereUniqueInput!) {
    node(where: $where) @rest(type: "Node", path: "node/{args.where.id}") {
      id
      displayName

      ... on DeviceNode {
        latitude
        longitude
      }
    }
  }
`;

interface Props {
  nodes?: any[];
  nodeId?: string;
  // startDate: number; // Date;
  // endDate: number; // Date;
  widgetStatic?: boolean;
  widgetTitle?: string;
}

const SunriseSunsetContainer = (props: Props) => {
  // TODO support one or more nodes (if a panelId is given, then a table of all lastest values is shown)
  const {
    // nodes,
    nodeId,
    // startDate,
    // endDate,
    widgetStatic,
    widgetTitle,
  } = props;
  const { data, error, loading } = useQuery(node, {
    variables: { where: { nodeId } },
    // suspend: true
  });
  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    console.error(error.message);
    return <div>Error! {error.message}</div>;
  }
  return (
    <SunriseSunset
      // nodes={nodes}
      data={data.node}
      widgetStatic={widgetStatic}
      widgetTitle={widgetTitle}
    />
  );
};

export default SunriseSunsetContainer;
